import {
  IAccountPrincipal,
  IResendVerificationRequest,
  IResendVerificationResponse,
  IResumeVerificationRequest,
  IUserConfirmationResult,
  IUserInit,
  IZeosUserClaimsContract,
  IZeosUserConfirmation,
} from "../contracts/Account";
import {
  deleteDataAsync,
  getDataAsync,
  postDataAsync,
} from "../ZeosApiExecutor";
import { IAccount } from "./interfaces/IAccount";

let accountPrefix = "/Account/";

export const Account: IAccount = {
  /*** Auth, Account***/
  getUserClaimsAsync: async (authSystemId: string) => {
    const response = await getDataAsync<IZeosUserClaimsContract>(
      `${accountPrefix}Claims/${authSystemId}`,
      "claims"
    );
    return response;
  },
  getUserClaimsWebAsync: async (authSystemId: string) => {
    const response = await getDataAsync<IZeosUserClaimsContract>(
      `${accountPrefix}Claims/?authSystemId=${authSystemId}`,
      "claims"
    );
    return response;
  },
  getAccountDetailsAsync: async (personId: number) => {
    const response = await getDataAsync<any>(
      `${accountPrefix}AccountDetails/${personId}`,
      ""
    );
    return response;
  },
  postUserAsync: async (user: IUserInit) => {
    const response = await postDataAsync<IZeosUserClaimsContract>(
      `${accountPrefix}CreateUser`,
      user
    );
    return response;
  },
  postAccountVerificationAsync: async (verification: IZeosUserConfirmation) => {
    const response = await postDataAsync<IUserConfirmationResult>(
      `${accountPrefix}UserConfirmation`,
      verification
    );
    return response;
  },
  postAccountSetupAsync: async (accountSetup: IZeosUserConfirmation) => {
    const response = await postDataAsync<IAccountPrincipal>(
      `${accountPrefix}CreateAccount`,
      accountSetup
    );
    return response;
  },
  resendVerificationCodeAsync: async (request: IResendVerificationRequest) => {
    const response = await postDataAsync<IResendVerificationResponse>(
      `${accountPrefix}ResendVerificationCode`,
      request
    );
    return response;
  },
  resumeVerificationCodeAsync: async (request: IResumeVerificationRequest) => {
    const response = await postDataAsync<IResendVerificationResponse>(
      `${accountPrefix}ResumeVerification`,
      request
    );
    return response;
  },
  // getProfileImageAsync: async (personId: number) => {
  //   const response = await getDataAsync<any>(
  //     `${accountPrefix}ProfileImage/${personId}`,
  //     ""
  //   );
  //   return response;
  // },
  // updateProfileImageAsync: async (data: FormData) => {
  //   const response = await putDataAsync<any>(
  //     `${accountPrefix}UpdateProfileImage`,
  //     data,
  //     true
  //   );
  //   return response;
  // },
  deactivateAccount: async (personId: number) => {
    const response = await deleteDataAsync<any>(
      `${accountPrefix}Deactivate/${personId}`,
      null
    );
    return response;
  },
  // sendVerificationEmail: async (
  //   emailNotification: EmailNotificationContract
  // ) => {
  //   const response = await postDataAsync<any>(
  //     `${accountPrefix}SendVerificationEmail`,
  //     emailNotification
  //   );
  //   return response;
  // },
  // sendPasswordResetEmailAsync: async (emailAddress: string) => {
  //   const response = await getDataAsync<any>(
  //     `${accountPrefix}SendPasswordResetEmail/${emailAddress}`,
  //     ""
  //   );
  //   return response;
  // },
};
